import { MapPinIcon, ShareIcon } from "@heroicons/react/24/outline";
import { shareOnMobile } from "react-mobile-share";
import { Button } from "@/components/ui/button";
import avatarImg from "@/assets/default_pfp.jpg";

export const ClinicianDetails = ({ clinician }) => {
    const url = window.location.href.toString();

    return (
        <div className="px-4 pt-7 pb-3">
            <div className="relative container mx-auto">
                <div className="flex gap-4 text-sm">
                    <div className="grid w-full min-w-24 flex-1 shrink-0 md:max-w-24 lg:max-w-30">
                        <img
                            src={clinician.profileImageUrl || avatarImg}
                            alt={`${clinician.firstName} ${clinician.lastName}`}
                            className="aspect-square w-full rounded-full object-cover"
                        />
                        <Button
                            variant="secondary"
                            size="sm"
                            className="mt-2 w-full"
                            onClick={() =>
                                shareOnMobile({
                                    title: `${clinician.firstName} ${clinician.lastName} - ${clinician.professionTitle}`,
                                    url,
                                    text: `Check out ${clinician.firstName} ${clinician.lastName} on Welnido.`,
                                    // images: [imgBase64]
                                })
                            }
                        >
                            <ShareIcon />
                            Share
                        </Button>
                    </div>
                    <div className="grid max-w-2/3 flex-auto content-start items-start gap-2 md:max-w-1/3">
                        <div>
                            <p className="text-2xl font-medium">
                                {clinician.firstName + " " + clinician.lastName}
                            </p>
                            <p className="text-base/6 text-neutral-500">
                                {clinician.professionTitle}
                            </p>
                        </div>
                        <div className="flex items-center gap-1">
                            <MapPinIcon className="size-4" />
                            <p>
                                {clinician.addressTown},{" "}
                                {clinician.addressCounty}
                            </p>
                        </div>
                        <div>
                            <p className="text-darkgreen-400">
                                {clinician.about}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
